


















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiarioDocumento from "@/models/tramite/tramiteBeneficiarioDocumento.model";
import BTableColumn from "@/models/base/BTableColumn.model";
import fileService, { getDocumentDownloadErrorMessage } from "@/services/file.service";

@Component
export default class TramiteBeneficiarioTableDocumentoComponent extends BaseVue {
  @Prop() readonly tramiteBeneficiarioId!: number;
  documentoTable = new BTableConfig<TramiteBeneficiarioDocumento>();
 
  created() {
    this.setupDocumentoTable();
  }

  setupDocumentoTable() {
    let docType = new BTableColumn("tipoDocumentoNombre","Tipo de documento",false);
    let doc = new BTableColumn("documento.nombreOriginal", "Documento");
    let preview = new BTableColumn("preview", " ", false);
    preview.customTemplate = true;
    preview.width = "60";
    this.documentoTable.controller = "TramiteBeneficiarioDocumento";
    this.documentoTable.enableDefaultColumns = false;
    this.documentoTable.activeActions = false;
    this.documentoTable.include = "Documento";

    this.documentoTable.insertColumns(preview, docType, doc);
    this.$emit('render',this.documentoTable);
  }
 async verDocumento(id: number) {
    try {
      await fileService.download(id);
    } catch (error) {
      this.operationFailed(getDocumentDownloadErrorMessage(error));
    }
  }
   @Watch("tramiteBeneficiarioId", { immediate: true })
  onPersonaIdChange(value: number | undefined | null) {
    if (!value) 
      return;
    this.documentoTable.whereParams = `tramiteBeneficiarioId=${value}`;
    if (this.documentoTable.reload) this.documentoTable.reload();
  }
}
